module.exports = __webpack_public_path__ + "media/mms-tab-logo.dc84867c.svg";